module.exports = __webpack_public_path__ + "static/GrayGminaMalechowo-68ffe92855d21710aebe4b029a5553cb.svg";